export default __webpack_public_path__ + "static/media/n2.b191900e.svg";